const canSeePrice = () => checkUserAbility('canSeePrice')
const canSeeCost = () => checkUserAbility('canSeeCost')
const canSeeWholesale = () => checkUserAbility('canSeeWholesale')
const canSeeMargin = () => checkUserAbility('canSeeMargin')
const canEditCads = () => checkUserAbility('canEditCads')
const canDeleteCads = () => checkUserAbility('canDeleteCads')
const canImpersonateUsers = () => checkUserAbility('canImpersonateUsers')
const canSeeContainerTotals = () => checkUserAbility('canSeeContainerTotals')
const canSeeTotals = () => checkUserAbility('canSeeTotals')

const checkUserAbility = (ability) => {
  return window.currentUserCustomAccess != null ? !!window.currentUserCustomAccess[ability] : false
}

export {canSeePrice, canSeeCost, canSeeWholesale, canSeeMargin, canEditCads, canDeleteCads, canImpersonateUsers, canSeeContainerTotals, canSeeTotals}
